export default __webpack_public_path__ + "static/media/Empty Photo.02d79cc1.png";